import React from "react";

import "./stylesIOSNotificationPreview.css";

import { ClockCircleOutlined } from "@ant-design/icons";
import { AppStrings } from "../../../../../../utils/constants/AppStrings";
import { BRAND_ICONS_URLS } from "../../../../../../utils/Constants";

function IOSNotificationPreview({ notificationData }) {
  const { title, description, dateTime, timeLeft } = notificationData;

  return (
    <div className="ios-notification-preview-container">
      <h3>{AppStrings.COMMUNICATION_PREVIEW}</h3>
      <button className="notification-button">
        <span>{AppStrings.NOTIFICATION}</span>
      </button>
      <div className="ios-preview">
        <div className="ios-preview-content">
          <div className="ios-preview-content-left-content">
            <img src={process.env.REACT_APP_ADMIN_PANEL_CLOUDFRONT_URL + BRAND_ICONS_URLS.primaryCurrencySymbol} alt="cash icon" className="cash-svg" />
          </div>
          <div className="ios-preview-content-right-content">
            <span className="ios-preview-content-date">{dateTime}</span>
            <span className="ios-preview-content-hours-left">
              <ClockCircleOutlined className="ios-preview-content-clock-icon" />
              {timeLeft}
            </span>
            <h4 className="ios-preview-content-title">{title}</h4>
            <span className="ios-preview-content-description">
              {description}
            </span>
            <div className="buttons">
              <button className="ios-preview-content-button learn-more">
                <span>{AppStrings.LEARN_MORE}</span>
              </button>
              <button className="ios-preview-content-button go-to-wallet">
                <span>{AppStrings.GO_TO_WALLET}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IOSNotificationPreview;
